import React from 'react';
import {
    Button,
    useUpdateMany,
    useRefresh,
    useNotify,
    useUnselectAll,
} from 'react-admin';
import SendIcon from '@mui/icons-material/Send';

const MarkAsSent = (params) => {
    const refresh = useRefresh();
    const notify = useNotify();
    const unselectAll = useUnselectAll();
    const [updateMany, { loading }] = useUpdateMany(
        params.resource,
        params.selectedIds,
        { markAsSent: true },
        {
            onSuccess: () => {
                refresh();
                notify('Items enabled');
                unselectAll(params.resource);
            },
            onFailure: error =>
                notify('Error: items are not updated', 'warning'),
        },
    );

    return (
        <Button color="primary" label="Mark as Sent" disabled={loading} onClick={updateMany}>
            <SendIcon />
        </Button>
    );
};

export default MarkAsSent;